var map = {
	"./battlefield.jpg": [
		4223,
		223
	],
	"./final-destination.jpg": [
		3182,
		182
	],
	"./hollow-bastion.jpg": [
		5851,
		851
	],
	"./kalos.jpg": [
		3067,
		67
	],
	"./pokemon-stadium-2.jpg": [
		3413,
		413
	],
	"./small-battlefield.jpg": [
		2461,
		461
	],
	"./smashville.jpg": [
		7969,
		969
	],
	"./town-and-city.jpg": [
		9897,
		897
	],
	"./yoshis-story.jpg": [
		7644,
		644
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 157;
module.exports = webpackAsyncContext;